/* @flow */

import React from "react";
import { Link } from "react-router";

import { FormattedMessage } from "react-intl";
import { trackChooseCategory, trackChooseHeaderCategory } from "../../../../utils/SearchTrackingUtil";
import { SearchQuery } from "shared/src/types/articlesearch/SearchResult";

type Props = {
    query: SearchQuery;
    urlCategoryPath: string;
    categoryName: string | undefined | null;
    categoryAmounts: number | undefined | null;
    queryLinkComponent: any;
    className?: string | null;
    itemPrefix?: JSX.Element;
    rootName?: JSX.Element;
    header?: boolean;
};

class CategoryFilterItem extends React.Component<Props> {
    handleClick() {
        const categoryName = this.props.categoryName ? this.props.categoryName : "all";
        const query = this.props.query.q || "";
        if (this.props.header) {
            trackChooseHeaderCategory(categoryName, query);
        } else {
            trackChooseCategory(categoryName, query);
        }
    }

    render() {
        const categoryName = this.props.categoryName;
        const query = this.props.query;
        const urlCPath = this.props.urlCategoryPath;
        const newQuery = Object.assign({}, query, { categoryPath: urlCPath });
        const className = "category-filter " + (this.props.className || "");
        const QueryLinkComponent = this.props.queryLinkComponent;
        // Some default props.
        const {
            itemPrefix = (
                <span>
                    <span className="icon-small-chevron-left" />
                    &nbsp;
                </span>
            ),
            rootName = <FormattedMessage id="EX_FILTER_PANEL_ALL_CATEGORIES" />
        } = this.props;
        if (!categoryName) {
            if (this.props.header) {
                return (
                    <Link to="/" onClick={this.handleClick.bind(this)} className={className}>
                        {itemPrefix}
                        {rootName}
                    </Link>
                );
            } else {
                return (
                    <QueryLinkComponent query={newQuery} className={className} onClick={this.handleClick.bind(this)}>
                        {itemPrefix}
                        {rootName}
                    </QueryLinkComponent>
                );
            }
        } else if (this.props.categoryAmounts) {
            return (
                <QueryLinkComponent query={newQuery} className={className} onClick={this.handleClick.bind(this)}>
                    <span>{categoryName + " (" + this.props.categoryAmounts + ")"}</span>
                </QueryLinkComponent>
            );
        } else {
            return (
                <QueryLinkComponent query={newQuery} className={className} onClick={this.handleClick.bind(this)}>
                    {itemPrefix}
                    <span>{this.props.categoryName}</span>
                </QueryLinkComponent>
            );
        }
    }
}
export default CategoryFilterItem;
